<template>
  <div>
    <header class="sticky-top border-bottom">
      <div class="rainbow-line rainbow-line-sm">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container checkoutHeader">
        <div class="row">
          <div class="col-2 col-md-2">
            <router-link
              to
              @click.native="() => $router.push({ name: 'Home Page' })"
            >
                              <img src="@/assets/logos/logo-2.png" class="logoImg" />

            </router-link>
          </div>
          <div class="col-8 col-md-6 align-self-center"></div>
          <div class="col-2 text-center col-md-4 align-self-center">
            <div class="bookingFlow-close d-md-none">
              <router-link
                @click.native="() => $router.push({ name: 'Home Page' })"
                to
              >
                <img src="@/assets/img/icons/booking-flow-close-red.svg" alt />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section class="section-finalTicket">
      <div class="container">
        <div class="section-space-50 d-none d-md-block"></div>
        <div class="row justify-content-center">
          <div class="col-2 pr-0 pr-md-3 col-md-2 col-lg-1 text-center">
            <img
              src="@/assets/img/icons/character2.svg"
              class="img-fluid"
              alt="character Icon"
            />
          </div>
          <div class="col-8 col-md-8 col-lg-6 text-center">
            <p class="confirm-text mob-fs-18">
              Congratulations! Your booking is confirmed.
            </p>
            <p class="d-none d-md-block">
              You have successfully booked food and beverages for
              <span class="text-rose-gold">
                {{ ticket && ticket.Film_strTitle }} </span
              >. You will be receiving a confirmation email shortly.
            </p>
            <p>
              Booking ID:
              <span class="font-weight-bold">
                {{ ticket && ticket.intBookId }}
              </span>
            </p>
          </div>
          <div class="col-2 pl-0 pl-md-3 col-md-2 col-lg-1 text-center">
            <img
              src="@/assets/img/icons/character1.svg"
              class="img-fluid"
              alt="character Icon"
            />
          </div>
        </div>
        <div class="section-space-50"></div>

        <!-- TICKET START -->
        <div
          class="col-12 col-md-11 col-lg-9 col-xl-8 mx-auto FinalTicket px-md-5 px-4 py-4 overflow-hidden"
        >
          <div class="row">
            <div class="col-4 col-md-2">
              <img
                v-lazy="
                  ticket && ticket.image_path_1
                    ? IMAGE_URL + ticket.image_path_1
                    : null
                "
                alt="Movie Banner"
                class="img-fluid"
              />
            </div>
            <div class="col-8 col-md-8 pl-1 pl-sm-2 pl-md-3">
              <p class="titleText font-weight-600 mb-1">
                {{ ticket && ticket.Film_strTitle }}
              </p>
              <ul class="list-inline titleText d-none d-md-block">
                <li class="list-inline-item">
                  {{ ticket && ticket.Session_dtmRealShow | dateparse }}
                  |
                  {{ ticket && ticket.Session_dtmRealShow | timeparse }}
                </li>
              </ul>
              <div class="">
                <p class="mb-0">{{ ticket && ticket.Cinema_strName }}</p>
                <p class="mb-0">{{ ticket && ticket.cinema_address }}</p>
              </div>
            </div>
            <div class="col-md-2 d-md-block d-none text-right">
              <p class="mb-0 text-center font-weight-bold fs-24">
               No of Ticket: {{ ticket && ticket.number_of_seats }}
              </p>
              <p class="text-center fs-12">
                {{
                  ticket && ticket.number_of_seats === 1 ? "Ticket" : "Tickets"
                }}
              </p>

              <div v-if="ticket">
                <img
                  :src="
                    'http://api.qrserver.com/v1/create-qr-code/?data=' +
                      ticket.intBookId +
                      '+&size=100x100'
                  "
                  alt
                />
                <span class="text-left mr-1">
                  {{ ticket && ticket.strBookId }}</span
                >
              </div>
            </div>
          </div>

          <!-- DATE SECTION FOR MOBILE SITE -->
          <div class="row d-md-none my-4">
            <div class="col-8">
              <p class="smallLightText mb-1">Date</p>
              <p class="mb-0 titleText font-weight-bold">
                {{ ticket && ticket.Session_dtmRealShow | dateparse }}
              </p>
            </div>
            <div class="col-4 text-right">
              <p class="smallLightText mb-1">Time</p>
              <p class="mb-0 titleText font-weight-bold">
                {{ ticket && ticket.Session_dtmRealShow | timeparse }}
              </p>
            </div>
          </div>
          <!-- DATE SECTION FOR MOBILE SITE -->

          <!-- SHOW THIS IF USER SELECTED F&B -->
          <div class="row mt-1 mt-md-3" v-if="ticket && ticket.items">
            <div class="col-12 col-md-10 offset-md-2">
              <div class="d-flex">
                <div class="mr-2 mt-1">
                  <img
                    src="@/assets/img/icons/popcorn-icon.svg"
                    alt="Popcorn Icon"
                  />
                </div>
                <div class>
                  <p class="mb-0">Food &amp; Beverage</p>
                  <ul
                    class="list-inline lightText fnbList"
                    v-for="(ticketItem, ticketItemIndex) in ticket.items"
                    :key="ticketItemIndex"
                  >
                    <li class="list-inline-item">
                      {{ ticketItem.quantity }}
                      {{ ticketItem.Item_strDescription }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- SHOW THIS IF USER SELECTED F&B -->

          <div class="row dividerLine my-4"></div>

          <div class="row">
            <div class="col-8">
              <p class="smallLightText mb-1">SEAT NO.</p>
              <ul class="list-inline mb-0 seatList titleText font-weight-bold">
                <!-- v-for="(seat, seatIndex) in 5" -->
                <!--  :key="seatIndex" -->
                <li class="list-inline-item mob-fs-14">
                  {{ ticket && ticket.strSeatInfo }}
                </li>
              </ul>
            </div>
            <div class="col-4 d-none d-md-block text-right">
              <p class="smallLightText mb-1">FND AMOUNT PAID</p>
              <p class="mb-0 titleText font-weight-bold">
                ₹{{ ticket && ticket.amount }}
              </p>
            </div>

            <!-- VISIBLE ON MOBILE SITE -->
            <div class="col-4 text-center lh-2 d-md-none">
              <p class="tickesNum mb-0 fs-20">
                {{ ticket && ticket.number_of_seats }}
              </p>
              <p class="titleText fs-14">
                {{
                  ticket && ticket.number_of_seats === 1 ? "Ticket" : "Tickets"
                }}
              </p>
            </div>
            <!-- VISIBLE ON MOBILE SITE -->
          </div>
        </div>
        <!-- TICKET END -->
        <div class="section-space-50"></div>
        <div
          class="col-12 col-md-11 col-lg-9 col-xl-8 mx-auto px-md-5 px-4 py-4 overflow-hidden d-none d-md-block"
        >
          <div class="row">
            <div class="col-md-6 mb-3 mb-md-0">
              <router-link
                to
                class="btn btn-primary w-100"
                @click.native="
                  () =>
                    getIsUserLogged
                      ? $router.push({
                          name: 'User Profile',
                          params: { component_name: 'myTransactions' }
                        })
                      : null
                "
                >VIEW MY BOOKINGS</router-link
              >
            </div>
            <!-- <div class="col-md-6 mb-3 mb-md-0">
              <button
                class="btn btn-outline-primary w-100"
                @click="$bvModal.show('sendGift')"
              >
                SEND THIS AS A GIFT
              </button>
            </div> -->
          </div>
        </div>

        <div class="section-space-50"></div>
      </div>
      <!-- FINAL TICKET MOBILE BUTTONS -->
      <div class="mobile-filter-footer d-md-none">
        <div
          class="mobile-filter-btn clear-btn"
          @click="$bvModal.show('sendGift')"
        >
          Send as gift
        </div>
        <router-link
          to
          class="mobile-filter-btn apply-btn"
          @click.native="
            () =>
              getIsUserLogged
                ? $router.push({
                    name: 'User Profile',
                    params: { component_name: 'myTransactions' }
                  })
                : null
          "
          >View my bookings</router-link
        >
      </div>
    </section>
    <!-- SEND TICKET AS GIFT MODAL -->
    <b-modal
      id="sendGift"
      title="Register With Miraj"
      class="imp-popup"
      hide-footer
    >
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row">
              <div class="col-12 my-3 px-3 text-center">
                Please enter details for the person who will receive this ticket
                as a gift.
              </div>

              <!-- ************ -->
              <form>
                <div class="form-row">
                  <div class="col-12 mb-3">
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      placeholder="Enter Full Name"
                      required
                    />
                    <div class="small text-danger">Test Message</div>
                  </div>
                  <!-- vue-tel-input -->
                  <!-- <div class="col-12 mb-3">
                  <vue-tel-input v-model="phone" class="pl-0 form-control"></vue-tel-input>
                  <div class="small text-danger">Test Message</div>
                  </div>-->
                  <!-- hide if use tel-input -->
                  <div class="col-12 mb-3">
                    <div class="form-row">
                      <div class="col-3">
                        <div
                          class="has-chevron"
                          :class="countryCode ? 'chevron-inverse' : ''"
                        >
                          <input
                            type="search"
                            placeholder="+ 91"
                            v-model="searchCountry"
                            v-on:blur="countryCode = !countryCode"
                            v-on:focus="countryCode = !countryCode"
                            class="form-control"
                          />
                        </div>
                        <div
                          class="select-location-box countryCode"
                          v-if="countryCode"
                        >
                          <ul class="search-result-list">
                            <li
                              v-for="(countryCode, countryCodeIndex) in 10"
                              :key="countryCodeIndex"
                            >
                              +91
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-9">
                        <input
                          type="number"
                          class="form-control"
                          id="validationCustom02"
                          placeholder="Enter Phone number"
                          required
                        />
                      </div>
                    </div>
                    <div class="small text-danger">Test Message</div>
                  </div>
                  <!-- ********** -->
                  <div class="col-12 mb-3">
                    <textarea
                      placeholder="Type your message here.."
                      name
                      id
                      cols="30"
                      rows="5"
                      class="form-control"
                    ></textarea>
                    <div class="small text-danger">Test Message</div>
                  </div>
                </div>

                <button
                  class="btn btn-primary w-100"
                  type="submit"
                  @click="$bvModal.show('GiftSentDone')"
                >
                  Proceed
                </button>
              </form>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
        </div>
      </div>
    </b-modal>

    <!-- GIFT SENT MODAL -->
    <b-modal id="GiftSentDone" title="Gift sent" class="imp-popup" hide-footer>
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row my-4">
              <div class="col-12 text-center">
                <img src="@/assets/img/icons/check-icon.svg" alt="Success" />
              </div>
              <div class="col-12 text-center my-4">
                <p>
                  Congrats Sachin! The ticket for John Wick 3 has
                  <br />been sent as a gift.
                </p>
              </div>
              <div class="col-12">
                <button class="btn btn-primary w-100">DONE</button>
              </div>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import TransactionService from "@/apiServices/TransactionService";
import { mapState, mapGetters, mapActions } from "vuex";
import { IMAGEURL } from "@/config";
import Vue from "vue";
export default {
  data() {
    return {
      IMAGE_URL: IMAGEURL,
      countryCode: false,
      searchCountry: "",
      ticket: null
    };
  },
  beforeMount() {
    const { transaction_id } = this.$route.params;
    if (transaction_id) {
      this.getFinalTicket(transaction_id);
    } else {
      this.$router.go(-1);
    }
  },

  methods: {
    async getFinalTicket(transaction_id) {
      let loader = Vue.$loading.show();
      try {
        this.ticket = null;
        const response = await TransactionService.GetFinalTicket({
          transaction_id,
          only_fnd: true
        });
        const { data } = response;
        if (data && data.status) {
          this.ticket = data.data;
          console.log("this.ticket", this.ticket);
        }
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
      }
    }
  },
  computed: {
    ...mapGetters(["getLoggedUser", "getIsUserLogged"])
  }
};
</script>

<style scoped>
/* header {
  display: none !important;
}
.cinema-footer {
  display: none !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/onlyFndFinalTicket.vue